// ПОЛЬЗОВАТЕЛЬСКИЕ META-ПЕРЕМЕННЫЕ:

// Был ли уже показан юзеру первый экран
export const SELLER_META_HAS_SHOW_WELCOME = 'has_show_welcome_screen';

// Создавал ли юзер стратегии (отвечает за показ модалки о создании первой стратегии)
export const SELLER_META_HAS_SHOW_MODAL_CREATE_FIRST_STRATEGY = 'has_show_modal_create_first_strategy';

// Дата окончания триала (нужно для корректного рассчёта 3х дней с момента окончания триала)
export const SELLER_META_TRIAL_DATE_LEFT_SUBSCRIPTION = 'trial_date_left_subscription';

// Был ли показан юзеру первый онбординг
export const SELLER_META_HAS_FINISH_ONBOARDING_CAMPAIGN_LIST_FIRST = 'has_finish_onboarding_campaign-list-first';

// Список фильтров статусов, которые были выбраны юзером
export const SELLER_META_FILTER_STATUS_LIST = 'filter_status_list';

// Список невалидных магазинов, которые мы игнорируем в уведомлении
export const SELLER_META_INVALID_SHOPS_LIST = 'invalid_shops_list';

// Показывать ли виджет с результатами биддера
export const SELLER_META_IS_PERFORMANCE_WIDGET_ENABLED = 'is_performance_widget_enabled';

// Посещал ли пользователь страницу статистики
export const SELLER_META_HAS_VISITED_STAT_PAGE = 'has_visited_stat_page';

// ПРОЕКТНЫЕ META-ПЕРЕМЕННЫЕ:

// Список показываемых ключей метрик для отображения в результаты биддера
export const SELLER_META_SHOW_KEYS_METRICS = 'show_keys_metrics_performance_bidder';

// Список показанных ключей(id) тех. работ
export const SELLER_META_TECH_WORKS_VIEWED_LIST = 'tech_works_viewed_list';

// Был ли показан юзеру уведомление о увеличении НДС
export const SELLER_META_VAT_INCREASE_NOTIFY_VIEWED_2026 = 'vat_increase_notify_viewed_2026';
